module.exports = __webpack_public_path__ + "static/img/e-logo-h5.2e78d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/e-logo-h5.png
// module id = A4R0
// module chunks = 34